import { fetchAuthSession } from "aws-amplify/auth";

const configuredApiBaseUrl = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");
const PUBLIC_API_FALLBACK_URL = (process.env.REACT_APP_PUBLIC_API_URL || "https://mentoria-api-one.vercel.app").replace(/\/$/, "");

function resolveApiBaseUrl() {
  if (configuredApiBaseUrl) return configuredApiBaseUrl;

  if (typeof window !== "undefined") {
    const { protocol, hostname } = window.location;
    if (hostname === "localhost" || hostname === "127.0.0.1") {
      return `${protocol}//${hostname}:4000`;
    }
  }

  return PUBLIC_API_FALLBACK_URL;
}

export function apiUrl(path) {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${resolveApiBaseUrl()}${normalizedPath}`;
}

export function publicApiUrl(path) {
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${resolveApiBaseUrl() || PUBLIC_API_FALLBACK_URL}${normalizedPath}`;
}

// Mensagem padrao pra quando o fetch em si falha (rede offline, DNS, CORS
// bloqueado, timeout) - nesses casos o navegador rejeita a Promise com um
// TypeError cru ("Failed to fetch", "NetworkError when attempting to fetch
// resource...", etc.) que nao deve chegar no usuario final. Isso e diferente
// de um erro HTTP normal (4xx/5xx), que a API respondeu de verdade e ja tem
// mensagem em português no payload.
const NETWORK_ERROR_MESSAGE = "Não foi possível conectar com o servidor. Verifique sua internet e tente novamente.";

export function isNetworkError(error) {
  return error?.code === "NETWORK_ERROR";
}

export async function apiRequest(path, options = {}) {
  const session = await fetchAuthSession();
  const idToken = session.tokens?.idToken?.toString();

  let response;
  try {
    response = await fetch(apiUrl(path), {
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...(idToken ? { Authorization: `Bearer ${idToken}` } : {}),
        ...(options.headers || {}),
      },
    });
  } catch (networkError) {
    const error = new Error(NETWORK_ERROR_MESSAGE);
    error.code = "NETWORK_ERROR";
    error.cause = networkError;
    throw error;
  }

  const contentType = response.headers.get("content-type") || "";
  const payload = contentType.includes("application/json")
    ? await response.json().catch(() => ({}))
    : { content: await response.text().catch(() => "") };

  if (!response.ok) {
    const error = new Error(payload.error || "Erro ao chamar a API.");
    error.status = response.status;
    error.code = payload.code;
    error.details = payload.details;
    throw error;
  }

  return payload;
}

export function downloadApiFile(file) {
  const mimeType = file.mimeType || "text/plain;charset=utf-8";
  const blob = file.contentBase64
    ? base64ToBlob(file.contentBase64, mimeType)
    : new Blob([file.content || JSON.stringify(file.files || file, null, 2)], { type: mimeType });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = file.filename || "qa-iniciante-export.txt";
  link.click();
  URL.revokeObjectURL(url);
}

function base64ToBlob(base64, mimeType) {
  const binary = atob(base64);
  const bytes = new Uint8Array(binary.length);
  for (let index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.charCodeAt(index);
  }
  return new Blob([bytes], { type: mimeType });
}
